<script setup lang="ts">

const emit = defineEmits<{
  (e: 'change', file: File): void
}>()

const loadImage = () => {
  const input = document.createElement("input")
  input.setAttribute("type", "file")
  input.setAttribute("accept", "image/jpg,image/jpeg,image/png,image/webp")
  input.setAttribute("style", "display: none;")
  input.onchange = onChange
  document.body.appendChild(input)
  input.click()
}

const onChange = (e: Event) => {
  const input = (e.target as HTMLInputElement)
  const file = input.files?.[0]
  if (file !== null && file !== undefined) {
    emit('change', file)
  }
  input.remove()
}

</script>
<template>
  <slot :load-image="loadImage" />
</template>
